import _ from "lodash";
import { actions } from "../../app/modules/Auth/_redux/authRedux";
import store from "../../redux/store";

export const makeQueryString = (obj: { [key: string]: string }) =>
  "?" + _.map(obj, (value, key) => `${key}=${value}`).join("&");

export const toAuthorAvatarName = (author) => {
  if (author !== null && author !== undefined) {
    let authorArr = author.split(" ");
    if (authorArr.length > 2) {
      authorArr = authorArr.slice(0, 2);
    }
    const authorInitials = authorArr.map((x) => x.charAt(0));
    return authorInitials.join("").toUpperCase();
  }
};

export const handleError = (err) => {
  let message = "Something went wrong";
  if (err?.response?.data?.statusCode) {
    const data = err.response.data;
    if (data.message && data.statusCode === 400) {
      message = data.message;
    } else if (data.statusCode === 401) {
      store.dispatch(actions.logout());
      message = data.message;
    }
  }

  return message;
};
